import { useSuspenseQuery } from '@tanstack/react-query';
import { getCharacterList } from '~/api';
import { MINUTE } from '~/constants';
import characterKey from './characterKey';

const useGetExploreCharacterListQuery = () => {
  return useSuspenseQuery({
    queryKey: characterKey.getExploreCharacterList(),
    queryFn: () => getCharacterList({ sort_by: 'main' }),
    select: ({ data, status }) => {
      return data;
    },
    staleTime: 30 * MINUTE,
  });
};

export default useGetExploreCharacterListQuery;
